import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { schemaValidation } from './constants';
import {
  IOffPlatformDefinitionFormFields,
  IOffPlatformDefinitionProps,
} from './types';

export const useOffPlatformDefinitionFormController = ({
  onSubmit,
  onCancel,
  defaultValues,
}: IOffPlatformDefinitionProps) => {
  const { control, handleSubmit, formState, reset } =
    useForm<IOffPlatformDefinitionFormFields>({
      resolver: yupResolver(schemaValidation),
    });

  const onSubmitHandler = handleSubmit((data) => {
    onSubmit(data);
  });

  const onCancelHandler = () => {
    onCancel();
  };

  const measurementFields = defaultValues?.measurements || [];

  useEffect(() => {
    if (defaultValues) {
      reset(defaultValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  return {
    control,
    formState,
    measurementFields,
    onSubmitHandler,
    onCancelHandler,
  };
};
